/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CheckIcon from "@mui/icons-material/Check";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PhonedIcon from "@mui/icons-material/PhoneRounded";
import CalendaIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineOutlined";
import ProjectRecording from "assets/images/icons/ProjectRecording.png";
import FileSearchIcon from "@mui/icons-material/FindInPageOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import NearMeIcon from "@mui/icons-material/NearMe";
import Goal from "assets/images/icons/Goal.png";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDProgress from "components/MDProgress";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { UserContext } from "context";
import invoiceTableData from "./data/projectsTableData";
import DataTable from "examples/Tables/DataTable";
import { useNotification } from "context/NotificationContext";
import InvoicesList from "components/InvoicesList";
import MapPin from "assets/images/icons/Map_Pin.png";
import Name from "assets/images/icons/Name.png";
import Phone from "assets/images/icons/Phone-3.png";
import Calendar from "assets/images/icons/Calendar.png";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

function Event() {
  const { user: loggedInUser } = useContext(UserContext);
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { eventId } = useParams();
  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [status, setStatus] = useState("Attesa di valutazione");
  const [anchorStatus, setAnchorStatus] = useState(null);
  const statusTextRef = useRef(null);
  const [isEditingAdmin, setIsEditingAdmin] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("Non impostato");
  const adminTextRef = useRef(null);
  const [anchorAdmin, setAnchorAdmin] = useState(null);
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [newLocation, setNewLocation] = useState("");
  const [dateAddressDialogOpen, setDateAddressDialogOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [newStartDate, setNewStartDate] = useState("");
  const [newEndDate, setNewEndDate] = useState("");
  const [newCity, setNewCity] = useState("");
  const [allEventTypes, setAllEventTypes] = useState([]);
  const [selectedEventType, setSelectedEventType] = useState("");
  const [eventTypeDialogOpen, setEventTypeDialogOpen] = useState(false);
  const [allPermissions, setAllPermissions] = useState([]);
  const [permissionDialogOpen, setPermissionDialogOpen] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState("");
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [comment, setComment] = useState("");
  const [isEditingDocumentationLink, setIsEditingDocumentationLink] = useState(false);
  const [documentationLink, setDocumentationLink] = useState("");
  const [advance, setAdvance] = useState("");
  const [total, setTotal] = useState("");
  const [invoice, setInvoice] = useState("");
  const [isEditingAdvance, setIsEditingAdvance] = useState(false);
  const [isEditingTotal, setIsEditingTotal] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [permissionToDelete, setPermissionToDelete] = useState(false);
  const [invoiceRows, setInvoiceRows] = useState([]);
  const [invoiceColumns, setInvoiceColumns] = useState([]);
  const [address, setAddress] = useState([]);
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [newStreet, setNewStreet] = useState("");
  const [newProvince, setNewProvince] = useState("");
  const [newHouseNumber, setNewHouseNumber] = useState("");
  const [newPostalCode, setNewPostalCode] = useState("");
  const [dateDialogOpen, setDateDialogOpen] = useState(false);
  const [eventNameDialogOpen, setEventNameDialogOpen] = useState(false);
  const [newEventName, setNewEventName] = useState("");
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const [nextCallDate, setNextCallDate] = useState("");
  const [editingDate, setEditingDate] = useState(false);
  const handleDateChange = (e) => setNextCallDate(e.target.value);
  const toggleEditingDate = () => setEditingDate((prev) => !prev);
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);

  const fetchEventDetails = async () => {
    fetch(`${apiUrl}/event/event_details.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ eventId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setError(data.message);
        } else {
          setAddress(data.addresses);
          setEventDetails(data);
          setStatus(data.event.status);
          const adminName = data.event.admin_name ? data.event.admin_name : "Non impostato";
          const adminSurname = data.event.admin_surname ? data.event.admin_surname : "";
          setSelectedAdmin(`${adminName} ${adminSurname}`.trim());
          setNewLocation(data.event.location);

          setNextCallDate(data.event.next_call_date);
          setLoading(false);
          return data;
        }
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchEventDetails();
  }, [eventId]);

  const handleStatusChange = async (newStatus) => {
    setStatus(newStatus);
    await saveStatus(newStatus);
    handleCloseMenu();
  };

  const handleStatusClick = () => {
    setAnchorStatus(statusTextRef.current);
  };

  const handleCloseMenu = () => {
    setAnchorStatus(null);
    setAnchorAdmin(null);
  };

  const saveStatus = async (newStatus) => {
    try {
      const response = await fetch(`${apiUrl}/event/update_status.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: eventDetails.event.id, status: newStatus }),
      });
      const result = await response.json();
      if (result.status === "success") {
        // Successfully updated the status
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const fetchAdmins = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/admins.php`);
      const admins = await response.json();
      setAdminList(admins);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const handleAdminChange = async (newAdmin) => {
    setSelectedAdmin(newAdmin.name + " " + newAdmin.surname);
    await saveAdmin(newAdmin);
    handleCloseMenu();
  };

  const handleAdminClick = () => {
    setAnchorAdmin(adminTextRef.current);
  };

  const saveAdmin = async (newAdmin) => {
    try {
      const admin = adminList.find(
        (admin) => `${admin.name} ${admin.surname}` === `${newAdmin.name} ${newAdmin.surname}`
      );
      const adminId = admin ? admin.id : null;

      const response = await fetch(`${apiUrl}/event/update_admin.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: eventDetails.event.id, admin_id: adminId }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setIsEditingAdmin(false);
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating admin:", error);
    }
  };

  const handleLocationChange = (event) => {
    setNewLocation(event.target.value);
  };

  const saveLocation = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/update_location.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: eventDetails.event.id, location: newLocation }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setLocationDialogOpen(false);
        setEventDetails((prevState) => ({
          ...prevState,
          event: {
            ...prevState.event,
            location: newLocation,
          },
        }));
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating location:", error);
    }
  };

  const handleAddressEdit = () => {
    if (eventDetails.addresses && eventDetails.addresses.length > 0) {
      const addr = eventDetails.addresses[0];
      setNewCity(addr.city || "");
      setNewProvince(addr.province || "");
      setNewStreet(addr.street || "");
      setNewHouseNumber(addr.house_number || "");
      setNewPostalCode(addr.postal_code || "");
      setAddressDialogOpen(true);
    }
  };

  const saveAddress = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/update_address.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          addressId: eventDetails.addresses[0].id,
          city: newCity,
          province: newProvince,
          street: newStreet,
          houseNumber: newHouseNumber,
          postalCode: newPostalCode,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setAddressDialogOpen(false);
        setEventDetails((prevState) => ({
          ...prevState,
          addresses: [
            {
              ...prevState.addresses[0],
              city: newCity,
              province: newProvince,
              street: newStreet,
              house_number: newHouseNumber,
              postal_code: newPostalCode,
            },
          ],
        }));
        setAddress([
          {
            ...address[0],
            city: newCity,
            province: newProvince,
            street: newStreet,
            house_number: newHouseNumber,
            postal_code: newPostalCode,
          },
        ]);
        showNotification({
          color: "success",
          icon: <Icon>check</Icon>,
          title: "Successo",
          dateTime: new Date().toLocaleString(),
          content: "Indirizzo aggiornato con successo!",
        });
      } else {
        console.error(result.message);
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Errore nell'aggiornamento dell'indirizzo",
        });
      }
    } catch (error) {
      console.error("Error updating address:", error);
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "Errore nell'aggiornamento dell'indirizzo",
      });
    }
  };

  const handleDateEdit = () => {
    if (eventDetails.dates && eventDetails.dates.length > 0) {
      const date = eventDetails.dates[0];
      setNewStartDate(date.start_date || "");
      setNewEndDate(date.end_date || "");
      setDateDialogOpen(true);
    }
  };

  const saveDate = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/update_dates.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          dateId: eventDetails.dates[0].id,
          startDate: newStartDate,
          endDate: newEndDate,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setDateDialogOpen(false);
        setEventDetails((prevState) => ({
          ...prevState,
          dates: [
            {
              ...prevState.dates[0],
              start_date: newStartDate,
              end_date: newEndDate,
            },
          ],
        }));
        showNotification({
          color: "success",
          icon: <Icon>check</Icon>,
          title: "Successo",
          dateTime: new Date().toLocaleString(),
          content: "Date aggiornate con successo!",
        });
      } else {
        console.error(result.message);
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Errore nell'aggiornamento delle date",
        });
      }
    } catch (error) {
      console.error("Error updating dates:", error);
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "Errore nell'aggiornamento delle date",
      });
    }
  };

  const handleEventNameEdit = () => {
    setNewEventName(eventDetails.event.event_name || "");
    setEventNameDialogOpen(true);
  };

  const saveEventName = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/update_event_name.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: eventDetails.event.id,
          eventName: newEventName,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setEventNameDialogOpen(false);
        setEventDetails((prevState) => ({
          ...prevState,
          event: {
            ...prevState.event,
            event_name: newEventName,
          },
        }));
        showNotification({
          color: "success",
          icon: <Icon>check</Icon>,
          title: "Successo",
          dateTime: new Date().toLocaleString(),
          content: "Nome evento aggiornato con successo!",
        });
      } else {
        console.error(result.message);
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Errore nell'aggiornamento del nome evento",
        });
      }
    } catch (error) {
      console.error("Error updating event name:", error);
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "Errore nell'aggiornamento del nome evento",
      });
    }
  };

  const handleDateAddressEdit = (index) => {
    const date = eventDetails.dates[index];
    const address = eventDetails.addresses[index];
    setNewStartDate(date.start_date);
    setNewEndDate(date.end_date);
    setNewCity(address.city);
    setEditingIndex(index);
    setDateAddressDialogOpen(true);
  };

  const saveDateAddress = async () => {
    if (editingIndex !== null) {
      // Editing existing date and address
      try {
        const response = await fetch(`${apiUrl}/event/update_dates_addresses.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: eventDetails.event.id,
            index: editingIndex,
            address_id: addresses[editingIndex].id,
            start_date: newStartDate,
            end_date: newEndDate,
            city: newCity,
          }),
        });
        const result = await response.json();
        if (result.status === "success") {
          setEventDetails((prevState) => {
            const updatedDates = [...prevState.dates];
            const updatedAddresses = [...prevState.addresses];
            updatedDates[editingIndex] = { start_date: newStartDate, end_date: newEndDate };
            updatedAddresses[editingIndex] = { city: newCity };
            return {
              ...prevState,
              dates: updatedDates,
              addresses: updatedAddresses,
            };
          });
          setDateAddressDialogOpen(false);
          fetchEventDetails();
        } else {
          console.error(result.message);
        }
      } catch (error) {
        console.error("Error updating dates and addresses:", error);
      }
    } else {
      // Adding new date and address
      try {
        const response = await fetch(`${apiUrl}/event/add_date_address.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: eventDetails.event.id,
            start_date: newStartDate,
            end_date: newEndDate,
            city: newCity,
          }),
        });
        const result = await response.json();
        if (result.status === "success") {
          setEventDetails((prevState) => ({
            ...prevState,
            dates: [...prevState.dates, { start_date: newStartDate, end_date: newEndDate }],
            addresses: [...prevState.addresses, { city: newCity }],
          }));
          setDateAddressDialogOpen(false);
          fetchEventDetails();
        } else {
          console.error(result.message);
        }
      } catch (error) {
        console.error("Error adding new date and address:", error);
      }
    }
    setEditingIndex(null);
  };

  // Function to fetch event types from the database
  const fetchEventTypes = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/event_types.php`);
      const eventTypes = await response.json();
      setAllEventTypes(eventTypes);
    } catch (error) {
      console.error("Error fetching event types:", error);
    }
  };

  // Function to add an event type to the database
  const addEventTypeToEvent = async (eventId, eventTypeId) => {
    const response = await fetch(`${apiUrl}/event/add_event_type.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId, eventTypeId }),
    });
    const result = await response.json();
    if (result.status === "success") {
      fetchEventDetails();
    } else {
      console.error(result.message);
    }
  };

  // Function to remove an event type from the database
  const removeEventTypeFromEvent = async (eventId, eventTypeId) => {
    await fetch(`${apiUrl}/event/remove_event_type.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId, eventTypeId }),
    });
  };

  const handleEventTypeChange = async () => {
    const currentEventType = eventDetails.event.event_type;
    if (selectedEventType && selectedEventType !== currentEventType) {
      try {
        // Remove the old event type from the event
        if (currentEventType) {
          await removeEventTypeFromEvent(eventDetails.event.id, currentEventType);
        }

        // Add the new event type to the event
        await addEventTypeToEvent(eventDetails.event.id, selectedEventType);

        // Update the state with the new event type
        setEventDetails((prevState) => ({
          ...prevState,
          event: {
            ...prevState.event,
            event_type: selectedEventType,
          },
        }));

        setEventTypeDialogOpen(false);
      } catch (error) {
        console.error("Error updating event type:", error);
      }
    }
  };

  const handleRemoveEventType = async (eventType) => {
    try {
      await removeEventTypeFromEvent(eventDetails.event.id, eventType);
      setEventDetails((prevState) => ({
        ...prevState,
        event_types: prevState.event_types.filter((type) => type !== eventType),
      }));
    } catch (error) {
      console.error("Error removing event type:", error);
    }
  };

  const fetchAllPermissions = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/permissions.php`);
      const data = await response.json();
      setAllPermissions(data);
    } catch (error) {
      console.error("Error fetching all permissions:", error);
    }
  };

  const handleRemovePermission = async (permission) => {
    try {
      await fetch(`${apiUrl}/event/remove_permission.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ eventId, permission }),
      });
      fetchEventDetails();
    } catch (error) {
      console.error("Error removing permission:", error);
    }
    setDeleteDialogOpen(false);
  };

  const handleAddPermission = async () => {
    try {
      await fetch(`${apiUrl}/event/add_permission.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ eventId, permission: selectedPermission }),
      });
      setPermissionDialogOpen(false);
      setSelectedPermission("");
      fetchEventDetails();
    } catch (error) {
      console.error("Error adding permission:", error);
    }
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSaveComment = async () => {
    setIsEditingComment(false);

    try {
      const response = await fetch(`${apiUrl}/event/update_comment.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ eventId, comment }),
      });

      if (!response.ok) {
        throw new Error("Failed to update comment");
      }

      const result = await response.json();
      fetchEventDetails();

      if (result.status !== "success") {
        throw new Error(result.message || "Failed to update comment");
      }
    } catch (error) {
      console.error("Error updating comment:", error);
    }
  };

  const handleDocumentationLinkChange = (event) => {
    setDocumentationLink(event.target.value);
  };

  const handleSaveDocumentationLink = async () => {
    setIsEditingDocumentationLink(false);

    try {
      const response = await fetch(`${apiUrl}/event/update_documentation_link.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ eventId, documentationLink }),
      });

      if (!response.ok) {
        throw new Error("Failed to update documentation link");
      }

      const result = await response.json();
      fetchEventDetails();

      if (result.status !== "success") {
        throw new Error(result.message || "Failed to update documentation link");
      }
    } catch (error) {
      console.error("Error updating documentation link:", error);
    }
  };

  const handleInvoiceChange = (event) => {
    setInvoice(event.target.value);
  };
  const handleSaveInvoice = async () => {
    setIsEditingAdvance(false);

    try {
      const response = await fetch(`${apiUrl}/event/update_invoice.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ eventId, invoice }),
      });

      if (!response.ok) {
        throw new Error("Failed to update invoice");
      }

      const result = await response.json();
      const { columns, rows } = invoiceTableData(result);
      setInvoiceColumns(columns);
      setInvoiceRows(rows);
      setEventDetails((prevDetails) => ({
        ...prevDetails,
        invoice: result.invoice,
      }));

      if (result.invoiceError) {
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore Fattura",
          dateTime: new Date().toLocaleString(),
          content: result.invoiceError,
        });
      } else {
        if (result.invoice) {
          setInvoice(invoice);
        }
        handleStatusChange("Attesa di pagamento");
      }

      if (result.status !== "success") {
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Failed to update invoice",
        });
        throw new Error(result.message || "Failed to update invoice");
      }
    } catch (error) {
      console.error("Error updating invoice:", error);
    }
  };

  const handleRequestPayment = async (invoiceDueDate, invoiceAmount) => {
    setIsEditingAdvance(false);

    try {
      const response = await fetch(`${apiUrl}/event/request_payment.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ eventId, invoiceDueDate, invoiceAmount }),
      });

      if (!response.ok) {
        throw new Error("Failed to send Request");
      }

      const result = await response.json();
      if (result.status !== "success") {
        throw new Error(result.message || "Failed to send Request");
      }
    } catch (error) {
      console.error("Error sending Request:", error);
    }
  };

  const fetchInvoiceDetails = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/invoice.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ invoice }),
      });
      const invoice = await response.json();
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  };

  const handleSendSummary = () => {
    // Logic to send summary and quotation
    setConfirmDialogOpen(false);
  };

  const handleDeletePermission = () => {
    // Logic to send summary and quotation
    setDeleteDialogOpen(false);
  };

  const handleArchiveEvent = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/archive_event.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ eventId }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        showNotification("Evento archiviato con successo", "success");
        setArchiveDialogOpen(false);
        navigate("/app/myEvents");
      } else {
        showNotification(result.message || "Errore nell'archiviazione dell'evento", "error");
      }
    } catch (error) {
      console.error("Error archiving event:", error);
      showNotification("Errore di connessione", "error");
    }
  };

  useEffect(() => {
    // Fetch admins and event types when component mounts
    fetchAdmins();
    fetchEventTypes();
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <MDTypography>Loading...</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <MDTypography>Error: {error}</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  const { event, addresses, dates, permissions, event_types } = eventDetails;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} pb={7}>
        <Card>
          <MDBox
            mx={2}
            mt={-10}
            py={3}
            px={2}
            variant="gradient"
            sx={{
              background: "linear-gradient(90deg, #41D4B9, #6E8ED1, #3A496A)",
            }}
            borderRadius="xl"
            coloredShadow="info"
          >
            <MDBox display="flex" justifyContent="flex-start" alignItems="center">
              <MDTypography
                fontWeight="bold"
                display="inline"
                variant="h1"
                color="white"
                title={`${event.event_name}`}
              >
                {event.event_name}
              </MDTypography>
              {loggedInUser.isAdmin && (
                <Icon
                  onClick={handleEventNameEdit}
                  sx={{ 
                    cursor: "pointer",
                    ml: 2,
                    fontSize: "2rem",
                    color: "#ffffff !important",
                    zIndex: 9999,
                    position: "relative",
                    pointerEvents: "auto",
                    "&:hover": {
                      opacity: 0.8
                    }
                  }}
                >
                  edit
                </Icon>
              )}
            </MDBox>
            <MDTypography
              color="white"
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
              variant="h5"
              fontWeight="light"
            >
              <MDTypography
                ref={statusTextRef}
                color="white"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  cursor: loggedInUser.isAdmin ? "pointer" : "default",
                }}
                variant="h5"
                fontWeight="light"
                onClick={loggedInUser.isAdmin ? handleStatusClick : null}
              >
                {status}
              </MDTypography>
              {loggedInUser.isAdmin && (
                <>
                  <ArrowDropDownIcon
                    fontSize="large"
                    onClick={handleStatusClick} // Reuse the same handler for the icon click
                    sx={{ cursor: "pointer" }} // Adjusted font size
                  />

                  <Menu
                    anchorEl={anchorStatus}
                    open={Boolean(anchorStatus)}
                    onClose={handleCloseMenu}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MenuItem onClick={() => handleStatusChange("Attesa di valutazione")}>
                      Attesa di valutazione
                    </MenuItem>
                    <MenuItem onClick={() => handleStatusChange("Attesa di pagamento")}>
                      Attesa di pagamento
                    </MenuItem>
                    <MenuItem onClick={() => handleStatusChange("In lavorazione")}>
                      In lavorazione
                    </MenuItem>
                    <MenuItem onClick={() => handleStatusChange("In Emissione")}>
                      In Emissione
                    </MenuItem>
                    <MenuItem onClick={() => handleStatusChange("Chiuso")}>Chiuso</MenuItem>
                  </Menu>
                </>
              )}
            </MDTypography>
          </MDBox>
          <MDBox mx={3} my={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={5}>
                <MDBox>
                  <MDBox display="flex" mb={2}>
                          <MDBox
                            component="img"
                            src={Phone}
                            alt="permission"
                            width="24px"
                            sx={{
                              width: { xs: "50px", sm: "32px" },
                              height: { xs: "50px", sm: "32px" },
                              cursor: "pointer",
                              marginRight:"8px"
                            }}
                          />
                    <MDBox>
                      {loggedInUser.isAdmin && editingDate ? (
                        <MDInput
                          type="datetime-local"
                          value={nextCallDate}
                          onChange={handleDateChange}
                          onBlur={() => {
                            toggleEditingDate();
                          }}
                          autoFocus
                        />
                      ) : (
                        <MDTypography color="text" fontWeight="bold" variant="h4">
                          {nextCallDate ? nextCallDate.replace(/\-/g, "/") : "Non impostato"}
                        </MDTypography>
                      )}
                      <MDTypography color="text" fontWeight="light" variant="h6">
                        Orario della prossima chiamata programmata
                      </MDTypography>
                    </MDBox>
                    {false &&
                      (editingDate ? (
                        <Icon
                          color="text"
                          onClick={() => {
                            toggleEditingDate();
                          }}
                          sx={{ cursor: "pointer" }}
                        >
                          check
                        </Icon>
                      ) : (
                        <Icon color="text" onClick={toggleEditingDate} sx={{ cursor: "pointer" }}>
                          edit
                        </Icon>
                      ))}
                  </MDBox>
                  <MDBox display="flex" mb={2} alignItems="center" width="100%">
                          <MDBox
                            component="img"
                            src={Calendar}
                            alt="permission"
                            width="24px"
                            sx={{
                              width: { xs: "50px", sm: "32px" },
                              height: { xs: "50px", sm: "32px" },
                              cursor: "pointer",
                              marginRight:"8px"
                            }}
                          />
                    <MDBox flex={1}>
                      <MDTypography color="text" fontWeight="bold" variant="h4">
                        {new Date(dates[0].start_date).toLocaleDateString().replace(/\./g, "/")} -{" "}
                        {new Date(dates[0].end_date).toLocaleDateString().replace(/\./g, "/")}
                      </MDTypography>
                      <MDTypography color="text" fontWeight="light" variant="h6">
                        {(() => {
                          const today = new Date();
                          const startDate = new Date(dates[0].start_date);
                          const endDate = new Date(dates[0].end_date);
                          const location = addresses[0].city;

                          if (today < startDate) {
                            // Event hasn't started yet
                            const daysUntilStart = Math.ceil(
                              (startDate - today) / (1000 * 60 * 60 * 24)
                            );
                            return (
                              <>
                                L'evento è tra{" "}
                                <span style={{ fontWeight: "bold" }}>{daysUntilStart}</span> giorni
                                a <span style={{ fontWeight: "bold" }}>{location}</span>
                              </>
                            );
                          } else if (today >= startDate && today <= endDate) {
                            // Event is currently ongoing
                            return (
                              <>
                                L'evento è attualmente in corso a{" "}
                                <span style={{ fontWeight: "bold" }}>{location}</span>
                              </>
                            );
                          } else {
                            // Event has ended
                            return (
                              <>
                                L'evento è terminato a{" "}
                                <span style={{ fontWeight: "bold" }}>{location}</span>
                              </>
                            );
                          }
                        })()}
                      </MDTypography>
                    </MDBox>
                    {loggedInUser.isAdmin && (
                      <Icon
                        color="text"
                        onClick={handleDateEdit}
                        sx={{ cursor: "pointer", ml: 1 }}
                      >
                        edit
                      </Icon>
                    )}
                  </MDBox>
                  <MDBox display="flex" mb={2}>
                          <MDBox
                            component="img"
                            src={Name}
                            alt="permission"
                            width="24px"
                            sx={{
                              width: { xs: "50px", sm: "32px" },
                              height: { xs: "50px", sm: "32px" },
                              cursor: "pointer",
                              marginRight:"8px"
                            }}
                          />
                    <MDBox>
                      <MDBox display="flex" alignItems="center">
                        <MDTypography
                          ref={adminTextRef}
                          color="text"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            cursor: loggedInUser.isAdmin ? "pointer" : "default",
                          }}
                          mr={1}
                          variant="h4"
                          fontWeight="bold"
                          onClick={loggedInUser.isAdmin ? handleAdminClick : null}
                        >
                          {selectedAdmin}
                        </MDTypography>
                        {loggedInUser.isAdmin && (
                          <>
                            <Icon
                              color="text"
                              onClick={handleAdminClick}
                              sx={{ cursor: "pointer" }}
                            >
                              edit
                            </Icon>
                            <Menu
                              anchorEl={anchorAdmin}
                              open={Boolean(anchorAdmin)}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              {adminList.map((admin) => (
                                <MenuItem onClick={() => handleAdminChange(admin)} key={admin.id}>
                                  {`${admin.name} ${admin.surname}`}
                                </MenuItem>
                              ))}
                            </Menu>
                          </>
                        )}
                      </MDBox>
                      <MDTypography color="text" fontWeight="light" variant="h6">
                        Il tuo referente PermessiOK
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                    <MDBox display="flex" mb={2} alignItems="center" width="100%">
                          <MDBox
                            component="img"
                            src={MapPin}
                            alt="permission"
                            width="24px"
                            sx={{
                              width: { xs: "50px", sm: "32px" },
                              height: { xs: "50px", sm: "32px" },
                              cursor: "pointer",
                              marginRight:"8px"
                            }}
                          />
                    <MDBox flex={1}>
                      <MDBox display="flex" alignItems="center">
                        <MDTypography
                          color="text"
                          variant="h4"
                          fontWeight="bold"
                        >
                          {address[0].street}
                        </MDTypography>
                      </MDBox>
                      <MDTypography color="text" fontWeight="medium" variant="h6">
                        {address[0].city}, {address[0].province} - {address[0].postal_code}
                      </MDTypography>
                      <MDTypography color="text" fontWeight="light" variant="h6">
                        L'indirizzo dell'Evento
                      </MDTypography>
                    </MDBox>
                    {loggedInUser.isAdmin && (
                      <Icon
                        color="text"
                        onClick={handleAddressEdit}
                        sx={{ cursor: "pointer", ml: 1 }}
                      >
                        edit
                      </Icon>
                    )}
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox sx={{ maxWidth: "600px", width: "100%" }}>
                  <MDBox mb={2}>
                    <MDTypography color="text" fontWeight="bold" variant="h4">
                      Stato avanzamento dei Permessi
                    </MDTypography>
                    <MDTypography color="text" fontWeight="light" variant="h6">
                      Lo stato stimato di avanzamento è il{" "}
                      {Math.floor(
                        (100 *
                          permissions.filter((permission) => permission.status === "Completo")
                            .length) /
                          permissions.length
                      )}
                      %
                    </MDTypography>
                  </MDBox>
                  <MDProgress
                    value={
                      permissions.length == 0
                        ? 0
                        : Math.floor(
                            (100 *
                              permissions.filter((permission) => permission.status === "Completo")
                                .length) /
                              permissions.length
                          )
                    }
                    color={
                      permissions.filter((permission) => permission.status === "Completo")
                        .length === permissions.length && permissions.length > 0
                        ? "primary"
                        : "primary"
                    }
                    variant="gradient"
                    label={false}
                    sx={{
                      mt: "auto",
                      width: "100%",
                      backgroundColor: "light.main",
                    }}
                  />
                  <MDBox
                    mt={3}
                    sx={{
                      position: "relative", // Set parent MDBox to relative for absolute positioning of the button
                      height: "100%", // Adjust height as needed
                      width: "100%", // Adjust width as needed
                    }}
                  >
                    <Card
                      sx={{
                        boxShadow: 0,
                        border: 1,
                        borderColor: "#D3D3D3",
                        backgroundColor: "light",
                      }}
                    >
                      <MDBox m={1.5}>
                        <MDTypography fontWeight="medium" mb={0.5} color="text">
                          Informazioni Utente
                        </MDTypography>
                        <MDTypography
                          fontWeight="medium"
                          color="secondary"
                          variant="h6"
                          sx={{ lineHeight: "170%" }}
                        >
                          {event.user_company}
                        </MDTypography>
                        <MDTypography
                          fontWeight="light"
                          color="text"
                          variant="h6"
                          sx={{ lineHeight: "140%" }}
                        >
                          {event.user_name}, {event.user_surname}
                        </MDTypography>
                        <MDTypography
                          fontWeight="light"
                          color="text"
                          variant="h6"
                          sx={{ lineHeight: "140%" }}
                        >
                          {event.user_street}
                        </MDTypography>
                        <MDTypography
                          fontWeight="light"
                          color="text"
                          variant="h6"
                          sx={{ lineHeight: "140%" }}
                        >
                          {event.user_city}
                        </MDTypography>
                        <MDTypography
                          fontWeight="light"
                          color="text"
                          variant="h6"
                          sx={{ lineHeight: "140%" }}
                        >
                          {event.user_phone}
                        </MDTypography>
                      </MDBox>
                    </Card>
                    {loggedInUser.isAdmin && (
                      <MDButton
                        variant="contained"
                        component="a"
                        color="dark"
                        href={`tel:${event.user_phone}`}
                        sx={{
                          backgroundColor: "#2C2C2C",
                          position: "absolute",
                          bottom: 16,
                          right: 16,
                          borderRadius: "8px",
                        }}
                      >
                        Chiama
                      </MDButton>
                    )}
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox py={1} pb={7}>
        <Card>
          <MDBox
            mx={2}
            mt={-4}
            py={3}
            px={2}
            sx={{
              backgroundColor: "#1E1E1E",
            }}
            variant="gradient"
            borderRadius="xl"
            coloredShadow="info"
            display="flex"
            alignItems="center"
          >
            <MDTypography fontWeight="bold" display="inline" variant="h4" color="white" mr={1}>
              Dati sull&apos;Evento
            </MDTypography>
            <MDBox component="img" src={ProjectRecording} alt="NewRequest" width="24px" my={-4} />
          </MDBox>
          <MDBox mx={3} my={2}>
            <Grid container spacing={3} sx={{ display: "flex", alignItems: "stretch" }}>
              {/* Card 1: Location */}
              <Grid item xs={12} md={6} lg={4}>
                <Card
                  sx={{
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <MDBox m={2}>
                    <MDTypography color="text" fontWeight="bold" variant="h4">
                      Location
                    </MDTypography>
                    <MDTypography color="text" fontWeight="light" variant="h6">
                      {event.location}
                    </MDTypography>
                  </MDBox>
                  {loggedInUser.isAdmin && (
                    <IconButton
                      onClick={() => setLocationDialogOpen(true)}
                      sx={{ position: "absolute", top: 12, right: 12 }}
                    >
                      <Icon>edit</Icon>
                    </IconButton>
                  )}
                </Card>
              </Grid>
              {/* Change Location Dialog */}
              <Dialog
                open={locationDialogOpen}
                onClose={() => setLocationDialogOpen(false)}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="form-dialog-title">Modifica Location</DialogTitle>
                <DialogContent>
                  <TextField
                    value={newLocation}
                    onChange={handleLocationChange}
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Inserisci la location dell'evento..."
                    sx={{ marginTop: 2 }}
                  />
                </DialogContent>
                <DialogActions>
                  <MDButton onClick={() => setLocationDialogOpen(false)} color="secondary">
                    Annulla
                  </MDButton>
                  <MDButton onClick={saveLocation} color="primary">
                    Salva
                  </MDButton>
                </DialogActions>
              </Dialog>
              {/* Change Address Dialog */}
              <Dialog
                open={addressDialogOpen}
                onClose={() => setAddressDialogOpen(false)}
                aria-labelledby="address-dialog-title"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="address-dialog-title">Modifica Indirizzo</DialogTitle>
                <DialogContent>
                  <TextField
                    label="Città"
                    value={newCity}
                    onChange={(e) => setNewCity(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  />
                  <TextField
                    label="Provincia"
                    value={newProvince}
                    onChange={(e) => setNewProvince(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginBottom: 2 }}
                  />
                  <TextField
                    label="Via"
                    value={newStreet}
                    onChange={(e) => setNewStreet(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginBottom: 2 }}
                  />
                  <TextField
                    label="Numero Civico"
                    value={newHouseNumber}
                    onChange={(e) => setNewHouseNumber(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginBottom: 2 }}
                  />
                  <TextField
                    label="CAP"
                    value={newPostalCode}
                    onChange={(e) => setNewPostalCode(e.target.value)}
                    fullWidth
                    variant="outlined"
                  />
                </DialogContent>
                <DialogActions>
                  <MDButton onClick={() => setAddressDialogOpen(false)} color="secondary">
                    Annulla
                  </MDButton>
                  <MDButton onClick={saveAddress} color="primary">
                    Salva
                  </MDButton>
                </DialogActions>
              </Dialog>
              {/* Change Dates Dialog */}
              <Dialog
                open={dateDialogOpen}
                onClose={() => setDateDialogOpen(false)}
                aria-labelledby="date-dialog-title"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="date-dialog-title">Modifica Date Evento</DialogTitle>
                <DialogContent>
                  <TextField
                    label="Data Inizio"
                    type="date"
                    value={newStartDate}
                    onChange={(e) => setNewStartDate(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    label="Data Fine"
                    type="date"
                    value={newEndDate}
                    onChange={(e) => setNewEndDate(e.target.value)}
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </DialogContent>
                <DialogActions>
                  <MDButton onClick={() => setDateDialogOpen(false)} color="secondary">
                    Annulla
                  </MDButton>
                  <MDButton onClick={saveDate} color="primary">
                    Salva
                  </MDButton>
                </DialogActions>
              </Dialog>
              {/* Change Event Name Dialog */}
              <Dialog
                open={eventNameDialogOpen}
                onClose={() => setEventNameDialogOpen(false)}
                aria-labelledby="event-name-dialog-title"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="event-name-dialog-title">Modifica Nome Evento</DialogTitle>
                <DialogContent>
                  <TextField
                    label="Nome Evento"
                    value={newEventName}
                    onChange={(e) => setNewEventName(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ marginTop: 2 }}
                  />
                </DialogContent>
                <DialogActions>
                  <MDButton onClick={() => setEventNameDialogOpen(false)} color="secondary">
                    Annulla
                  </MDButton>
                  <MDButton onClick={saveEventName} color="primary">
                    Salva
                  </MDButton>
                </DialogActions>
              </Dialog>
              {/* Card 2: Dates and Addresses */}
              <Grid item xs={12} md={6} lg={4}>
                <Card
                  sx={{
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <MDBox m={2}>
                    <MDTypography color="text" fontWeight="bold" variant="h4">
                      Data creazione
                    </MDTypography>
                    <MDTypography color="text" fontWeight="light" variant="h6">
                      {new Date(event.created).toLocaleDateString().replace(/\./g, "/")}
                    </MDTypography>
                  </MDBox>
                  {/* Change Start/End Date Button
                  <MDBox display="flex" justifyContent="center" mb={3}>
                    {loggedInUser.isAdmin && (
                      <MDButton
                        sx={{ marginTop: 3 }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setEditingIndex(null); // Reset editing index for new entry
                          setNewStartDate("");
                          setNewEndDate("");
                          setNewCity("");
                          setDateAddressDialogOpen(true);
                        }}
                      >
                        <MDTypography
                          variant="h6"
                          color="white"
                          fontWeight="medium"
                          textTransform="capitalize"
                          sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
                        >
                          Aggiungi <Icon>add</Icon>
                        </MDTypography>
                      </MDButton>
                    )}
                  </MDBox>
                  */}
                </Card>
              </Grid>
              {/* Change Start/End Date Dialog
              <Dialog open={dateAddressDialogOpen} onClose={() => setDateAddressDialogOpen(false)}>
                <DialogTitle>
                  {editingIndex !== null
                    ? "Modifica Date e Indirizzo"
                    : "Aggiungi Date e Indirizzo"}
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Data Inizio"
                    type="date"
                    fullWidth
                    value={newStartDate}
                    onChange={(e) => setNewStartDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    margin="dense"
                    label="Data Fine"
                    type="date"
                    fullWidth
                    value={newEndDate}
                    onChange={(e) => setNewEndDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    margin="dense"
                    label="Città"
                    type="text"
                    fullWidth
                    value={newCity}
                    onChange={(e) => setNewCity(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <MDButton onClick={() => setDateAddressDialogOpen(false)} color="secondary">
                    Annulla
                  </MDButton>
                  <MDButton onClick={saveDateAddress} color="primary">
                    Salva
                  </MDButton>
                </DialogActions>
              </Dialog>
              */}
              {/* Card 3: Event Types */}
              <Grid item xs={12} md={6} lg={4}>
                <Card
                  sx={{
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <MDBox m={2}>
                    <MDTypography color="text" fontWeight="bold" variant="h4">
                      Tipologia Evento
                    </MDTypography>
                    {eventDetails.event_types.map((type, index) => (
                      <MDBox
                        key={index}
                        mb={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDTypography color="text" fontWeight="light" variant="h6">
                          • {type}
                        </MDTypography>
                        {loggedInUser.isAdmin && (
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveEventType(type)}
                            sx={{ ml: 1 }}
                          >
                            <Icon fontSize="small" color="error">close</Icon>
                          </IconButton>
                        )}
                      </MDBox>
                    ))}
                  </MDBox>
                  {loggedInUser.isAdmin && (
                    <IconButton
                      onClick={() => {
                        fetchEventTypes();
                        setEventTypeDialogOpen(true);
                      }}
                      sx={{ position: "absolute", top: 12, right: 12 }}
                    >
                      <Icon>edit</Icon>
                    </IconButton>
                  )}
                </Card>
                {/* Change Event Type Dialog */}
                <Dialog open={eventTypeDialogOpen} onClose={() => setEventTypeDialogOpen(false)} maxWidth="sm" fullWidth>
                  <DialogTitle>Aggiungi Tipo di Evento</DialogTitle>
                  <DialogContent sx={{ mt: 2 }}>
                    <Select
                      displayEmpty
                      value={selectedEventType}
                      onChange={(e) => setSelectedEventType(e.target.value)}
                      fullWidth
                    >
                      <MenuItem value="">
                        <em>Seleziona un tipo di evento</em>
                      </MenuItem>
                      {allEventTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.event_type_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </DialogContent>
                  <DialogActions>
                    <MDButton onClick={() => setEventTypeDialogOpen(false)} color="secondary">
                      Annulla
                    </MDButton>
                    <MDButton onClick={handleEventTypeChange} color="primary">
                      Aggiungi
                    </MDButton>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox py={1} pb={7}>
        <Card>
          <MDBox
            mx={2}
            mt={-4}
            py={3}
            px={2}
            variant="gradient"
            sx={{
              backgroundColor: "#3A496A",
            }}
            borderRadius="xl"
            coloredShadow="info"
            display="flex"
            alignItems="center"
          >
            <MDTypography fontWeight="bold" display="inline" variant="h4" color="white" mr={1}>
              Permessi
            </MDTypography>
            <MDBox
              component="img"
              src={Goal}
              alt="NewRequest"
              width="24px"
              my={-4}
              sx={{
                cursor: "pointer",
              }}
            />
          </MDBox>
          <MDTypography fontWeight="light" display="inline" variant="h6" color="text" mt={2} ml={3}>
            Clicca sul permesso per vedere le azioni richieste o scaricare i permessi
          </MDTypography>
          <MDBox mx={3} my={3}>
            <Grid container spacing={3} sx={{ display: "flex", alignItems: "stretch" }}>
              {permissions.map((permission, index) => (
                <Grid
                  item
                  xs={12}
                  md={6}
                  lg={4}
                  key={index}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "100%" }}
                >
                  <MDButton
                    variant="contained"
                    color={permission.status === "Completo" ? "primary" : "light"}
                    onClick={() => {
                      navigate(
                        `/app/event/${eventDetails.event.id}/permission/${permission.permission_id}`
                      );
                    }}
                    sx={{
                      width: "100%",
                      maxWidth: "320px",
                      height: "140px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center", 
                      textAlign: "center", 
                      border: `1px solid ${
                        permission.status === "Completo"
                          ? "#primary"
                          : permission.status === "Azione Richiesta"
                          ? "#C28EA6"
                          : "#D9D9D9"
                      }`,
                      borderRadius: "8px",
                      boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {loggedInUser.isAdmin && (
                      <HighlightOffIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          setPermissionToDelete(permission.permission_name);
                          setDeleteDialogOpen(true);
                        }}
                        sx={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          color: "red",
                          cursor: "pointer",
                          fontSize: "1rem",
                        }}
                      />
                    )}
                    <MDBox>
                      <MDTypography
                        color={permission.status === "Completo" ? "white" : "text"}
                        fontWeight="bold"
                        variant="h5"
                        textTransform="capitalize"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {permission.permission_name}
                      </MDTypography>
                      <MDTypography
                        color={permission.status === "Completo" ? "white" : "text"}
                        fontWeight="light"
                        variant="h6"
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        {permission.status}
                      </MDTypography>
                    </MDBox>
                  </MDButton>
                </Grid>
              ))}

              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: "200px" }}
              >
                {loggedInUser.isAdmin && (
                  <MDButton
                    variant="contained"
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      minWidth: 0,
                      backgroundColor: "#f5f5f5",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                    onClick={() => {
                      fetchAllPermissions();
                      setPermissionDialogOpen(true);
                    }}
                  >
                    <Icon sx={{ fontSize: 30, color: "#000" }}>add</Icon>
                  </MDButton>
                )}
              </Grid>
            </Grid>
          </MDBox>

          <Dialog open={permissionDialogOpen} onClose={() => setPermissionDialogOpen(false)}>
            <DialogTitle>Aggiungi Permesso</DialogTitle>
            <DialogContent>
              <Select
                displayEmpty
                value={selectedPermission}
                onChange={(e) => setSelectedPermission(e.target.value)}
              >
                <MenuItem value="">
                  <em>Seleziona un permesso</em>
                </MenuItem>
                {allPermissions.map((permission) => (
                  <MenuItem key={permission.id} value={permission.id}>
                    {permission.permission}
                  </MenuItem>
                ))}
              </Select>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={() => setPermissionDialogOpen(false)} color="secondary">
                Annulla
              </MDButton>
              <MDButton onClick={handleAddPermission} color="primary">
                Aggiungi
              </MDButton>
            </DialogActions>
          </Dialog>
          <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
            <DialogTitle>Sei sicuro?</DialogTitle>
            <DialogContent>
              <MDTypography>Vuoi inviare il riepilogo e il preventivo?</MDTypography>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={() => setConfirmDialogOpen(false)} color="secondary">
                Annulla
              </MDButton>
              <MDButton onClick={handleSendSummary} color="primary">
                Invia
              </MDButton>
            </DialogActions>
          </Dialog>
          <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
            <DialogTitle>Sei sicuro?</DialogTitle>
            <DialogContent>
              <MDTypography>
                Sei sicuro di voler cancellare questo Permesso? Questo comporterà
                l&apos;eliminazione dei file al suo interno
              </MDTypography>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={() => setDeleteDialogOpen(false)} color="secondary">
                Annulla
              </MDButton>
              <MDButton onClick={() => handleRemovePermission(permissionToDelete)} color="primary">
                Invia
              </MDButton>
            </DialogActions>
          </Dialog>
          <Dialog open={archiveDialogOpen} onClose={() => setArchiveDialogOpen(false)}>
            <DialogTitle>Conferma Archiviazione</DialogTitle>
            <DialogContent>
              <MDTypography>
                Sei sicuro di voler archiviare questo evento? L&apos;evento non sarà più visibile nell&apos;elenco principale.
              </MDTypography>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={() => setArchiveDialogOpen(false)} color="secondary">
                Annulla
              </MDButton>
              <MDButton onClick={handleArchiveEvent} color="error">
                Archivia
              </MDButton>
            </DialogActions>
          </Dialog>
        </Card>
      </MDBox>
      {(eventDetails?.invoices?.length > 0 || loggedInUser.isAdmin) ? (
        <MDBox py={1} pb={7}>
          <Card>
            <MDBox
              mx={2}
              mt={-4}
              py={3}
              px={2}
              variant="gradient"
              sx={{
                backgroundColor: "#438E80",
              }}
              borderRadius="xl"
              coloredShadow="info"
              display="flex"
              alignItems="center"
            >
              <MDTypography fontWeight="bold" display="inline" variant="h4" color="white" mr={1}>
                {loggedInUser.isAdmin ? "Note e Quotazione" : "Quotazione Evento"}
              </MDTypography>
              <MDBox
                component="img"
                src={Goal}
                alt="NewRequest"
                width="24px"
                my={-4}
                sx={{
                  cursor: "pointer",
                }}
              />
            </MDBox>

            <MDBox mx={3} my={2}>
              {/* New Invoices List Component */}
              <InvoicesList
                invoices={eventDetails?.invoices || []}
                eventId={eventId}
                onInvoiceCreated={fetchEventDetails}
                isAdmin={loggedInUser.isAdmin}
              />
              
              <Grid container spacing={3} sx={{ display: "flex", alignItems: "stretch", marginTop: 3 }}>
                {/* Show invoice data for both proforma and invoice types */}
                {eventDetails?.invoice?.data ? (
                  <>
                    <Grid item xs={12} pt={3}>
                      <DataTable
                        table={{ columns: invoiceColumns, rows: invoiceRows }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <MDBox m={2}>
                        <MDTypography color="text" fontWeight="bold" variant="h4">
                          Invoice:{" "}
                          <MDTypography color="text" fontWeight="light" variant="h6">
                            {eventDetails?.invoice?.data?.url ? (
                              <a
                                href={eventDetails.invoice.data.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "inherit", textDecoration: "none" }}
                              >
                                {eventDetails.invoice.data.url}
                              </a>
                            ) : (
                              "No invoice available"
                            )}
                          </MDTypography>
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <Card
                        sx={{
                          boxShadow: 0,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <MDBox m={2}>
                          <MDTypography color="text" fontWeight="bold" variant="h1">
                            {eventDetails?.invoice?.data?.amount_gross} ‚¬
                          </MDTypography>
                          <MDTypography color="text" fontWeight="bold" variant="h4">
                            Totale
                          </MDTypography>
                          <MDTypography color="text" fontWeight="light" variant="h6">
                            Stima totale del costo dei Permessi richiesti
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>

                    {/* Saldo Finale Card */}
                    <Grid item xs={12} md={6} lg={4}>
                      <Card
                        sx={{
                          boxShadow: 0,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <MDBox m={2}>
                          <MDTypography color="text" fontWeight="bold" variant="h1">
                            {eventDetails?.invoice?.data?.amount_gross -
                              (eventDetails?.invoice?.data?.payments_list?.[0]?.paid_date &&
                                eventDetails?.invoice?.data?.payments_list?.[0]?.amount || 0)}{" "}
                            ‚¬
                          </MDTypography>
                          <MDTypography color="text" fontWeight="bold" variant="h4">
                            Saldo finale
                          </MDTypography>
                          <MDTypography color="text" fontWeight="light" variant="h6">
                            Quota da versare come saldo finale
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                  </>
                ) : undefined}
                {loggedInUser.isAdmin ? (
                  <>
                    {/* Notes Section */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          backgroundColor: isEditingComment ? "white" : "#f5f5f5", // Light grey background
                          boxShadow: 0,
                          border: isEditingComment ? "0px" : "1px solid #D3D3D3", // Light grey border
                          borderRadius: "10px", // Rounded corners
                          display: "flex",
                          justifyContent: "space-between",
                          position: "relative",
                        }}
                      >
                        <MDBox sx={{ width: "100%" }}>
                          {isEditingComment ? (
                            <TextField
                              value={comment}
                              onChange={handleCommentChange}
                              multiline
                              fullWidth
                              rows={5}
                              variant="outlined"
                              sx={{
                                border: "0px solid #D3D3D3",
                                resize: "vertical",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            <MDTypography
                              variant="body1"
                              color="text"
                              sx={{
                                margin: 1,
                                padding: 2,
                              }}
                            >
                              {event.comment || "Note..."}
                            </MDTypography>
                          )}

                          {/* Edit / Save Icon */}
                          <IconButton
                            onClick={() =>
                              isEditingComment
                                ? handleSaveComment()
                                : (() => {
                                    setComment(event.comment || "");
                                    setIsEditingComment(!isEditingComment);
                                  })()
                            }
                            sx={{ position: "absolute", top: 12, right: 12 }}
                          >
                            {isEditingComment ? <CheckIcon /> : <Icon>edit</Icon>}
                          </IconButton>
                        </MDBox>
                      </Card>
                    </Grid>

                    {/* Documentation Link Section - Only for admins */}
                    {loggedInUser.isAdmin && (
                      <Grid item xs={12}>
                        <Card
                          sx={{
                            backgroundColor: isEditingDocumentationLink ? "white" : "#f5f5f5",
                            boxShadow: 0,
                            border: isEditingDocumentationLink ? "0px" : "1px solid #D3D3D3",
                            borderRadius: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            position: "relative",
                          }}
                        >
                          <MDBox sx={{ width: "100%" }}>
                            {isEditingDocumentationLink ? (
                              <TextField
                                value={documentationLink}
                                onChange={handleDocumentationLinkChange}
                                fullWidth
                                variant="outlined"
                                placeholder="https://..."
                                sx={{
                                  border: "0px solid #D3D3D3",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "5px",
                                }}
                              />
                            ) : (
                              <MDBox sx={{ margin: 1, padding: 2 }}>
                                <MDTypography variant="body1" color="text" sx={{ marginBottom: event.documentation_link ? 1 : 0 }}>
                                  Documenti evento:
                                </MDTypography>
                                {event.documentation_link ? (
                                  <MDTypography variant="body1" color="info">
                                    <a
                                      href={
                                        event.documentation_link.startsWith('http://') || 
                                        event.documentation_link.startsWith('https://') 
                                          ? event.documentation_link 
                                          : `https://${event.documentation_link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#1976d2",
                                        textDecoration: "none",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {event.documentation_link}
                                    </a>
                                  </MDTypography>
                                ) : (
                                  <MDTypography variant="body2" color="text" fontStyle="italic">
                                    Nessun link impostato
                                  </MDTypography>
                                )}
                              </MDBox>
                            )}

                            {/* Edit / Save Icon */}
                            <IconButton
                              onClick={() =>
                                isEditingDocumentationLink
                                  ? handleSaveDocumentationLink()
                                  : (() => {
                                      setDocumentationLink(event.documentation_link || "");
                                      setIsEditingDocumentationLink(!isEditingDocumentationLink);
                                    })()
                              }
                              sx={{ position: "absolute", top: 12, right: 12 }}
                            >
                              {isEditingDocumentationLink ? <CheckIcon /> : <Icon>edit</Icon>}
                            </IconButton>
                          </MDBox>
                        </Card>
                      </Grid>
                    )}
                  </>
                ) : undefined}
              </Grid>
            </MDBox>
          </Card>
        </MDBox>
      ) : undefined}

      {/* Documentation Link Section - Display for non-admin users if link exists */}
      {!loggedInUser.isAdmin && eventDetails?.event?.documentation_link && (
        <MDBox py={1} pb={3}>
          <Card
            onClick={() => {
              const link = eventDetails.event.documentation_link;
              const fullLink = link.startsWith('http://') || link.startsWith('https://') 
                ? link 
                : `https://${link}`;
              window.open(fullLink, '_blank', 'noopener,noreferrer');
            }}
            sx={{
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 4,
              }
            }}
          >
            <MDBox p={3} display="flex" alignItems="center" justifyContent="space-between">
              <MDBox display="flex" alignItems="center">
                <Icon fontSize="large" color="info" sx={{ mr: 2 }}>
                  folder_open
                </Icon>
                <MDBox>
                  <MDTypography variant="h5" fontWeight="bold">
                    Documenti evento
                  </MDTypography>
                  <MDTypography variant="caption" color="text">
                    Clicca per aprire i documenti
                  </MDTypography>
                </MDBox>
              </MDBox>
              <Icon color="info">
                open_in_new
              </Icon>
            </MDBox>
          </Card>
        </MDBox>
      )}
      
      {/* Archive Event Button - Only visible to admins */}
      {loggedInUser.isAdmin && (
        <MDBox py={1} pb={3}>
          <Card>
            <MDBox p={3} display="flex" justifyContent="flex-end">
              <MDButton
                variant="contained"
                color="error"
                onClick={() => setArchiveDialogOpen(true)}
              >
                <Icon>archive</Icon>
                <MDTypography
                  ml={1}
                  color="white"
                  variant="h6"
                  fontWeight="medium"
                  textTransform="capitalize"
                >
                  Archivia Evento
                </MDTypography>
              </MDButton>
            </MDBox>
          </Card>
        </MDBox>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default Event;

